import React from 'react';
import axios from 'helpers/axios';

import { Container, Title, TextInput, Button, Form, Image, Label } from 'ui/components/styled';
import { AuthLayout } from 'ui/components/layouts';
import { useUser, useToasts, useLayout } from 'hooks';
import { ValidationPattern } from 'helpers/form';

export const PhoneValidate = () => {
  const [phone, setPhone] = React.useState('');
  const { setLayoutLoading } = useLayout();
  const { user, saveUser, redirectTo } = useUser();
  const { errorToast } = useToasts();

  React.useEffect(() => {
    if (user?.phone) {
      setPhone(user.phone);
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLayoutLoading(true);
      const response = await axios.post(`/uext/validations/send?type=phone&uid=${user.id}`, {
        changes: user.phone !== phone ? { phone } : {},
      });
      if (response.status === 200) {
        saveUser({ ...user, phone }, false);
        redirectTo('/phone/confirm');
        return;
      }
    } catch (error) {
      errorToast({ error, default: 'Error: Phone validate.' });
    }
    setLayoutLoading(false);
  };

  return (
    <AuthLayout justifyContent="start">
      <Container width="80%" maxWidth="480px" height="auto" top="15%">
        <Container alignItems="center" mb="xl">
          <Image alt="2FA" src="/assets/img/2FA.png" />
        </Container>
        <Title mb="m">Phone verification</Title>
        <Title type="h3" variant="grey" mb="m">
          Please validate your phone number
        </Title>
        <Form onSubmit={handleSubmit}>
          <Container>
            <Label htmlFor="phone" mb="xs">
              Phone number
            </Label>
            <TextInput
              id="phone"
              name="phone"
              type="tel"
              placeholder="Phone number"
              pattern={ValidationPattern.phone}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
              autoFocus
            />
          </Container>
          <Button type="submit" my="m">
            Send SMS
          </Button>
        </Form>
      </Container>
    </AuthLayout>
  );
};
